
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { SettlementPaymentModel } from './Entities.GormCrm.SettlementPayment';
import { SettlementProductPlanModel } from './Entities.GormCrm.SettlementProductPlan';
import { SettlementStatus } from 'enums/SettlementStatus';
import { Model, ModelProperty } from 'models/Model';


export class SettlementModel extends Model<SettlementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'number', type: 'number' },
		{ name: 'referenceNumber', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'userId', type: 'string' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'installments', type: 'number' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'comment', type: 'string' },
		{ name: 'reasonId', type: 'string' },
		{ name: 'dateSentToClient', type: 'Date' },
		{ name: 'acceptedByClient', type: 'Date' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'reason', type: 'ReasonModel', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } },
		{ name: 'settlementPayments', type: 'SettlementPaymentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementPaymentModel }, properties: () => { return SettlementPaymentModel.classProperties } },
		{ name: 'settlementProductPlans', type: 'SettlementProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementProductPlanModel }, properties: () => { return SettlementProductPlanModel.classProperties } },
		{ name: 'status', type: 'SettlementStatus' },
		{ name: 'settlementInstallments', type: 'SettlementInstallmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementInstallmentModel }, properties: () => { return SettlementInstallmentModel.classProperties } },
		{ name: 'isActive', type: 'boolean' },
		{ name: 'settlementSum', type: 'number' },
		{ name: 'settlementSumInclVat', type: 'number' },
		{ name: 'paymentSumInclVat', type: 'number' },
		{ name: 'amountRemainingInclVat', type: 'number' },
		{ name: 'isFullyPaid', type: 'boolean' }
	];
	[key: string]: any;
	
	public id?: string;
	public number: number;
	public referenceNumber: string;
	public companyId?: string;
	public userId?: string;
	public dueDate?: Date;
	public installments: number;
	public created?: Date;
	public comment: string;
	public reasonId?: string;
	public dateSentToClient?: Date;
	public acceptedByClient?: Date;
	public company?: CompanyModel;
	public reason?: ReasonModel;
	public settlementPayments: SettlementPaymentModel[];
	public settlementProductPlans: SettlementProductPlanModel[];
	public status: SettlementStatus;
	public settlementInstallments: SettlementInstallmentModel[];
	public isActive: boolean;
	public settlementSum: number;
	public settlementSumInclVat: number;
	public paymentSumInclVat: number;
	public amountRemainingInclVat: number;
	public isFullyPaid: boolean;
    
	constructor(){
		super();
		this.id = undefined;
		this.number = 0;
		this.referenceNumber = '';
		this.companyId = undefined;
		this.userId = undefined;
		this.dueDate = undefined;
		this.installments = 0;
		this.created = undefined;
		this.comment = '';
		this.reasonId = undefined;
		this.dateSentToClient = undefined;
		this.acceptedByClient = undefined;
		this.company = undefined;
		this.reason = undefined;
		this.settlementPayments = [];
		this.settlementProductPlans = [];
		this.status = 0;
		this.settlementInstallments = [];
		this.isActive = false;
		this.settlementSum = 0;
		this.settlementSumInclVat = 0;
		this.paymentSumInclVat = 0;
		this.amountRemainingInclVat = 0;
		this.isFullyPaid = false;
		
	}
	getProperties(){
		return SettlementModel.classProperties;
	}
}
export class SettlementInstallmentModel extends Model<SettlementInstallmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'number', type: 'number' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'amount', type: 'number' }
	];
	[key: string]: any;
	
	public number: number;
	public dueDate?: Date;
	public amount: number;
    
	constructor(){
		super();
		this.number = 0;
		this.dueDate = undefined;
		this.amount = 0;
		
	}
	getProperties(){
		return SettlementInstallmentModel.classProperties;
	}
}

